__turbopack_context__.v({
  "chartsSection": "StatsPage-module__CjxhBq__chartsSection",
  "container": "StatsPage-module__CjxhBq__container",
  "pageTitle": "StatsPage-module__CjxhBq__pageTitle",
  "pulse": "StatsPage-module__CjxhBq__pulse",
  "section": "StatsPage-module__CjxhBq__section",
  "skeleton": "StatsPage-module__CjxhBq__skeleton",
  "skeletonCard": "StatsPage-module__CjxhBq__skeletonCard",
  "skeletonChart": "StatsPage-module__CjxhBq__skeletonChart",
  "skeletonFilters": "StatsPage-module__CjxhBq__skeletonFilters",
  "skeletonGrid2": "StatsPage-module__CjxhBq__skeletonGrid2",
  "skeletonGrid4": "StatsPage-module__CjxhBq__skeletonGrid4",
});
